import React, { useEffect, useRef, useState } from 'react';
import { Checkbox, FormControlLabel, IconButton, InputBase } from '@material-ui/core';
import SearchIcon from "@material-ui/icons/Search";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import DeleteIcon from '@material-ui/icons/Delete';
import ExpandLess from "@material-ui/icons/ArrowDropDown";
import { useRecoilState, useSetRecoilState } from 'recoil';
import { debugList } from '../../../../../recoil-store/recoil-state';
import './debugger.css';

const useStylesSearch = makeStyles((theme) => ({
    root: {
        padding: "10px",
        display: "flex",
        alignItems: "center",
        background: "#FAFAFA",
        height: "2rem",
        width: "50%",
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
        borderRadius: "2px",
        fontSize: "12px"
    },
    iconButton: {
        padding: 10,
    },
}));
let debugItems = {};

function Debugger(props) {
    const [debugs, setDebugs] = useRecoilState(debugList);
    const setClearDebugs = useSetRecoilState(debugList);
    const classesSearch = useStylesSearch();
    const { t } = useTranslation();
    // Set initial states
    const datae = useRef(debugs);
    const [data, setData] = useState(datae.current);
    const [expand, setExpand] = useState(true);
    const [debugIntervalList, setDebugIntervalList] = useState({});
    const filters = useRef({ success: true, warning: true, failed: true, search: '' });
    const debugContainer = useRef();

    // Set state on debugList changme
    useEffect(() => {
        // setData(handleSearch(handleFilter(debugs)));
        if (debugs.length < 1) {
            debugItems = {};
        }
        setData(debugs);
        datae.current = debugs;
        handleHighlights(datae.current);
    }, [debugs]);

    useEffect(() => {
        props.setDebuggingExpand(expand);
    }, [expand, props]);

    const handleHighlights = (data) => {
        data.forEach(item => {
            if (item.items.length) {
                const errorItem = item.items.find(status => {
                    return status.DebugSeverity === "ERROR"
                })
                const completedItem = item.items.find(status => {
                    return status.Value === "COMPLETED"
                })
                const startedItem = item.items.find(status => {
                    return status.Value === "STARTED"
                })

                if (errorItem && errorItem.ItemId) {
                    const c = errorItem.Id;
                    if (debugItems[c] && debugItems[c] !== "ERROR") {
                        props.setDebugStatus(errorItem.ItemId, "error", errorItem.Value);
                        clearIntervalF(errorItem.ItemId);
                        debugItems[c] = "ERROR"
                    }
                } else {
                    if (completedItem && completedItem.ItemId) {
                        const c = completedItem.Id;
                        if (debugItems[c] && debugItems[c] !== "COMPLETED") {
                            clearIntervalF(completedItem.ItemId);
                            debugItems[c] = "COMPLETED"
                            props.setDebugStatus(completedItem.ItemId, "completed");
                        }
                    } else if (startedItem && startedItem.ItemId) {
                        const c = startedItem.Id;
                        if (!debugItems[c]) {
                            debugItems[c] = "STARTED"
                            let interval = { ...debugIntervalList };
                            interval[startedItem.ItemId] = setIntervalF(startedItem.ItemId);
                            setDebugIntervalList(interval);
                            props.setDebugStatus(startedItem.ItemId, "");
                        }
                    }
                }
            }
        });
    }

    const setIntervalF = (itemId) => {
        return setInterval(function () {
            if (document.getElementById("act_" + itemId)) {
                document.getElementById("act_" + itemId).classList.add("highlight")
                setTimeout(function () {
                    if (document.getElementById("act_" + itemId)) {
                        document.getElementById("act_" + itemId).classList.remove("highlight")
                    }
                }, 250);
            }
        }, 500);
    }

    const clearIntervalF = (itemId) => {
        clearInterval(debugIntervalList[itemId]);
        if (document.getElementById("act_" + itemId)) {
            document.getElementById("act_" + itemId)?.classList?.remove("highlight")
        }
    }

    // Handle search debug messages
    const handleInput = (e) => {
        filters.current.search = e.target.value;
        setData(handleSearch(handleFilter(datae.current)));
        if (!expand) setExpand(true);
    };
    // Handle checkbox click
    const handleCheckbox = (e) => {
        filters.current[e.target.name] = e.target.checked;
        setData(handleFilter(handleSearch(datae.current)));
        if (!expand) setExpand(true);
    };
    // Handle Search
    const handleSearch = (params) => {
        return params.filter(b => b.children.some(a => (a.DataMessage.LibraryName + ' ' + a.DataMessage.ActionName + ' ' + a.DataMessage.Value).toLowerCase().includes(filters.current.search.toLowerCase())));
    };
    // Handle success, warning or failed filters
    const handleFilter = (params) => {
        const { success, warning, failed } = filters.current;
        return params.filter(b => b.children.some(a => (success && a.DataMessage.DebugSeverity === 'INFO') || (warning && a.DataMessage.DebugSeverity === 'WARNING') || (failed && a.DataMessage.DebugSeverity === 'ERROR')));
    };
    // Handle clear console
    const handleClear = (e) => {
        setDebugs([]);
        setClearDebugs([])
    };
    return (
        <div
            className={`debugger-container ${props.showTriggerRightArea ? "w-45" : props.showRightArea ? "" : "full"} ${!expand ? "debugger-title" : ""}`}
            style={!props.openRunningModal ? { zIndex: 1 } : {}} ref={debugContainer}>
            <div className="debugger-search">
                <button onClick={handleClear}>
                    <DeleteIcon style={{ color: '#D75E5E' }} />
                </button>
                <div className={classesSearch.root}>
                    <IconButton
                        type="submit"
                        className={classesSearch.iconButton}
                        aria-label="search"
                        id="search-icon"
                    >
                        <SearchIcon />
                    </IconButton>
                    <InputBase
                        className={classesSearch.input}
                        placeholder={t("CONTENT.FLOW.SEARCH")}
                        defaultValue={filters.current.search}
                        onChange={handleInput}
                    />
                </div>
                <FormControlLabel
                    control={
                        <Checkbox
                            defaultChecked={filters.current.failed}
                            onChange={handleCheckbox}
                            name="failed"
                            size="small"
                            style={{ color: "#D6543A" }}
                        />
                    }
                    label={<span className="debugger-info">{t("CONTENT.FLOW.ERROR")}</span>}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            defaultChecked={filters.current.warning}
                            onChange={handleCheckbox}
                            name="warning"
                            size="small"
                            style={{ color: "#ECAC4B" }}
                        />
                    }
                    label={<span className="debugger-info">{t("CONTENT.FLOW.WARNING")}</span>}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            defaultChecked={filters.current.success}
                            onChange={handleCheckbox}
                            name="success"
                            size="small"
                            style={{ color: "#2968D1" }}
                        />
                    }
                    label={<span className="debugger-info">{t("CONTENT.FLOW.INFO")}</span>}
                />
                <div className="expand-debugger" onClick={() => setExpand(!expand)}>
                    <ExpandLess
                        style={{ color: "#959595", transform: expand ? "" : "rotate(180deg)" }}
                    />
                </div>
            </div>

            <div className="debugger-messages">
                {data.map((item, itemI) => {
                    return (
                        <div key={itemI}>
                            <input type="checkbox" id={'debugger-line-' + itemI} />
                            <span>&gt;</span>&nbsp;<label className="debugger-line header"
                                htmlFor={'debugger-line-' + itemI}>
                                <div>{item.header}</div>
                                <div>{(item.time)}</div>
                            </label>
                            {item.items.map((obj, objI) => {
                                return (
                                    <div key={objI} style={{ marginLeft: 10 }}
                                        className={`debugger-line ${obj.DebugSeverity.toLowerCase()}`}>
                                        <div>{obj.LibraryName + ' ' + obj.ActionName + ' ' + obj.Value}</div>
                                        <div>{obj.time}</div>
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default Debugger;
